import React, { useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Button, Dialog, DialogTitle, DialogContent, Typography
} from '@mui/material';
import moment from 'moment';

const ProfileChangesTable = ({ profileChanges }) => {
    const [open, setOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState('');

    const handleOpenDialog = (description) => {
        setSelectedDescription(description);
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
        setSelectedDescription('');
    };

    const truncate = (text, maxLength = 200) =>
        text.length > maxLength ? text.substring(0, maxLength) + '...' : text;

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="profile changes table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Channel Name</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Subscribers</TableCell>
                            <TableCell>Views</TableCell>
                            <TableCell>Links</TableCell>
                            <TableCell>Verified</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {profileChanges.map((profile) => (
                            <TableRow key={profile.id} hover>
                                <TableCell>
                                    {moment(profile.date_profile_state).format('MMMM Do YYYY, h:mm:ss a')}
                                </TableCell>
                                <TableCell>{profile.channel_name}</TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                        {truncate(profile.channel_description)}
                                    </Typography>
                                    {profile.channel_description.length > 200 && (
                                        <Button size="small" onClick={() => handleOpenDialog(profile.channel_description)}>
                                            View Full
                                        </Button>
                                    )}
                                </TableCell>
                                <TableCell>{profile.subscriber_count_string}</TableCell>
                                <TableCell>{profile.view_count_string}</TableCell>
                                <TableCell>{profile.link_count}</TableCell>
                                <TableCell>{profile.verified ? '✔️' : '❌'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Dialog for Full Description */}
            <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>Channel Description</DialogTitle>
                <DialogContent>
                    <Typography sx={{ whiteSpace: 'pre-line' }}>
                        {selectedDescription}
                    </Typography>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ProfileChangesTable;
